import sales_icon from 'assets/images/sales_icon.png';
import attendance from 'assets/images/attendance.png';
import shipping from 'assets/images/shipping.png';
import profile from 'assets/images/profile.png';
import samplecheck from 'assets/images/samplecheck.png';
import inventory from 'assets/images/inventory.png';
import ledgerCurrentYear from 'assets/images/ledgercurrentyear.png';
import ledgerdivisionwise from 'assets/images/ledgerdivisionwise.png';
import stockDownloadImage from 'assets/images/stock_download.png';
import productAssessmentImage from 'assets/images/product_assessment.png';
import assessmentReport from 'assets/images/assessment_reports.png';
import vendorLeadger from 'assets/images/Ledger.png';
import ptFile from 'assets/images/ptFIle.png';
import BeatManagement from 'assets/images/BeatManagement.png';
import marketIntelligence from 'assets/images/marketIntelligence.png';
import ProductCatalogue from 'assets/images/product_catlogue.png';
import goodsReturn from 'assets/images/GoodsReturn.png';
import pendindorderreports from 'assets/images/pendingorderreport.png';
import paymentreceived from 'assets/images/paymentreceived.png';
import outstandingreport from 'assets/images/outstandingreport.png';
import outstanding1 from 'assets/images/outstanding1.png';
import home from 'assets/images/house.png';
import sampleRequest from 'assets/images/sampleRequest.png';
import salesplanning from 'assets/images/salesplanning.png';
import kpi from 'assets/images/kpi.png';
import scheme from 'assets/images/scheme.png';
import collachiv from 'assets/images/collachiv.png';
import dashboard from 'assets/images/dashboard.png';
import billing from 'assets/images/billing.png';
import claim from 'assets/images/claim.png';
import timemanagement from 'assets/images/time-management.png';

const baseMenuList = [
  /* ================= EXPLORE ================= */
  {
    title: 'Explore',
    slug: 'explore',
    subItems: [
      { name: 'Dashboard', slug: 'dashboard', nav: '/report-dashboard', image: home },
      { name: 'Classic Console', slug: 'classic-console', nav: '/dashboard', image: dashboard },
      { name: 'Sales Order', slug: 'sales-order', nav: '/salesorder', image: sales_icon },
      { name: 'My Orders', slug: 'my-orders', nav: '/myordersreport', image: shipping },
      // { name: 'Sales Order Performa', slug: 'sales-performance', nav: '/sales-performer', image: sales_icon }
    ]
  },

  /* ================= ACTIVITIES ================= */
  {
    title: 'Activities',
    slug: 'activities',
    subItems: [
      { name: 'Customer Profile', slug: 'customer-profile', nav: '/customerProfile', image: profile },
      { name: 'Sample Check', slug: 'sample-check', nav: '/samplecheck', image: samplecheck },
      { name: 'Stock Upload', slug: 'stock-upload', nav: '/stockupload', image: inventory },
      { name: 'Check Barcode Stock', slug: 'check-barcode-stock', nav: '/check-barcode-for-stock', image: inventory },
      { name: 'Sales Order Upload', slug: 'sales-order-upload', nav: '/salesOrderUpload', image: sales_icon },
      { name: 'Product Assessment', slug: 'product-assessment', nav: '/passessment', image: productAssessmentImage },
      { name: 'BEATS', slug: 'beats', nav: '/beats', image: BeatManagement },
      { name: 'Market Intelligence', slug: 'market-intelligence', nav: '/market-intelligence', image: marketIntelligence },
      { name: 'Product Catalogue', slug: 'product-catalogue', nav: '/product-catalogue', image: ProductCatalogue },
      { name: 'Sample Request', slug: 'sample-request', nav: '/view-sample-request', image: sampleRequest },
      { name: 'Denknit Sample Process', slug: 'Denknit-sample-process-flow', nav: '/Denknit-sample_process', image: inventory },
      { name: 'Denknit Sales Order Summary Report', slug: 'denknit-sales-order-summary-report', nav: '/denknit-sales-order-summary-report', image: sales_icon },
      { name: 'Denknit Sample Process Summary Report', slug: 'denknit-sample-process-summary-report', nav: '/denknit-sample-process-summary-report', image: sales_icon },
      { name: 'Denknit Summary Report', slug: 'denknit-summary-report', nav: '/denknit-summary-report', image: sales_icon },
      { name: 'Secondary Sales Order', slug: 'secondary-sales-order', nav: '/secondary-sales-order', image: sales_icon },
      {
        name: 'Sales Person Entry for Visit',
        key: 'sales_person_entry_for_visit',
        slug: 'sales-person-entry-for-visit',
        nav: '/sales-person-entry-for-visit',
        image: sales_icon
      },
      { name: 'Tour Expense Claim', slug: 'tour_expense_claim', nav: '/tour-expense-claim', image: claim },
      { name: 'Display and Events', slug: 'display-and-events', nav: '/display-and-events', image: timemanagement },
      { name: 'Sales Planning', slug: 'sales-planning', nav: '/dashboard-sales-planning', image: salesplanning },
      { name: 'Good Returns', slug: 'good-returns', nav: '/good-returns-list', image: goodsReturn }
    ]
  },

  /* ================= LEDGER ================= */
  {
    title: 'Ledger',
    slug: 'ledger',
    subItems: [
      { name: 'Ledger Current Year', slug: 'ledger-current-year', nav: '/ledgerCurrentYear', image: ledgerCurrentYear },
      { name: 'Ledger Previous Year', slug: 'ledger-previous-year', nav: '/ledgerPreviousYear', image: ledgerCurrentYear },
      { name: 'Vendor Ledger', slug: 'vendor-ledger', nav: '/vendorLedger', image: vendorLeadger },
      { name: 'Division Wise Ledger', slug: 'division-wise-ledger', nav: '/ledgerDiv', image: ledgerdivisionwise, disabled: false },
      { name: 'Division Wise Previous Ledger', slug: 'division-wise-previous-ledger', nav: '/previousDivWiseLedger', image: ledgerdivisionwise, disabled: false }
    ]
  },

  /* ================= OUTSTANDING ================= */
  {
    title: 'Outstanding',
    slug: 'outstanding',
    subItems: [
      { name: 'Outstanding', slug: 'outstanding-summary', nav: '/divoutstanding', image: outstanding1 },
      { name: 'Division Outstanding', slug: 'division-outstanding', nav: '/divoutstandingnew', image: outstanding1, disabled: false }
    ]
  },

  /* ================= REPORTS ================= */
  {
    title: 'Reports',
    slug: 'reports',
    subItems: [
      { name: 'My Attendance', slug: 'my-attendance', nav: '/attedancereport', image: attendance },
      { name: 'Assessment Reports', slug: 'assessment-reports', nav: '/assessment-reports', image: assessmentReport },
      { name: 'KPI Report', slug: 'kpi-report', nav: '/distributorkpi-reports', image: kpi },
      { name: 'Pending Order Reports', slug: 'pending-order-reports', nav: '/pending-order-reports', image: pendindorderreports },
      { name: 'Outstanding Reports', slug: 'outstanding-reports', nav: '/outstanding-reports', image: outstandingreport },
      { name: 'NON BILLED', slug: 'non-billed-reports', nav: '/non-billed-reports', image: billing },
      { name: 'Payment Received', slug: 'payment-received', nav: '/collection-recieved', image: paymentreceived },
      // { name: 'Scheme Report', nav: '/scheme-report', image: scheme },
      // { name: 'Collection Target vs Achivemnet (Received)', slug: 'collection-target-achievement', nav: '/collection-target-achv-report', image: collachiv },
      { name: 'Current Months Sales Figure', slug: 'current-month-sales-report', nav: '/current-month-sales-report', image: collachiv },
      { name: 'Sales Perform Report', slug: 'sales-performer-report', nav: '/sales-performer-report', image: collachiv },
      { name: 'Agency Performance', slug: 'agency-performance', nav: '/agency-performance-report', image: sales_icon },
      { name: 'Dealer One page report', slug: 'dealer-one-page-report', nav: '/dealer-one-page-report', image: sales_icon },
      { name: 'Agency One page report', slug: 'agency-one-page-report', nav: '/agency-one-page-report', image: sales_icon },

    ]
  },

  /* ================= DOWNLOADS ================= */
  {
    title: 'Downloads',
    slug: 'downloads',
    subItems: [

      { name: 'Download', slug: 'download', nav: '/stockdownload', image: stockDownloadImage },
      { name: 'PT File', slug: 'pt-file', nav: '/ptFile', image: ptFile }
    ]
  }
];

export const getMenuListByUserType = (userType = '', userCode = '') => {
  const canAccessGoodReturns = String(userCode || '') === '272101';
  const menuWithGoodReturnsAccess = baseMenuList.map((section) => ({
    ...section,
    subItems: section.subItems.filter(
      (item) => item.name !== 'Good Returns' || canAccessGoodReturns
    )
  }));

  return menuWithGoodReturnsAccess;
};

const normalizeMenuValue = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/&/g, 'and');

//     const hardcodedMenuKeys = new Set([
//   normalizeMenuValue('Dealer One page report'),
//   normalizeMenuValue('dealer-one-page-report'),
//   normalizeMenuValue('/dealer-one-page-report'),
//   normalizeMenuValue('Agency One page report'),
//   normalizeMenuValue('agency-one-page-report'),
//   normalizeMenuValue('/agency-one-page-report')
// ]);

const getStoredLoginMenus = () => {
  try {
    if (typeof window === 'undefined') return [];
    return JSON.parse(localStorage.getItem('loginMenu') || '[]');
  } catch {
    return [];
  }
};

const getStoredUser = () => {
  try {
    if (typeof window === 'undefined') return {};
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

const filterMenuByLoginAccess = (menuList, loginMenus = []) => {
  if (!Array.isArray(loginMenus) || loginMenus.length === 0) {
    return menuList;
  }

  const allowedChildren = new Set();
  const childDisplayOrder = new Map();
  const sectionDisplayOrder = new Map();

  const addDisplayOrder = (orderMap, keys, displayOrder) => {
    const order = Number(displayOrder);
    if (!Number.isFinite(order)) return;

    keys.forEach((key) => {
      if (!orderMap.has(key)) orderMap.set(key, order);
    });
  };

  loginMenus.forEach((menuItem) => {
    const slug = normalizeMenuValue(menuItem?.menuSlug);
    const name = normalizeMenuValue(menuItem?.menuName);
    const path = normalizeMenuValue(menuItem?.routePath);
    const keySet = [slug, name, path].filter(Boolean);

    if (Number(menuItem?.menuLevel) === 0 || menuItem?.isParent) {
      addDisplayOrder(sectionDisplayOrder, keySet, menuItem?.displayOrder);
      return;
    }

    keySet.forEach((key) => allowedChildren.add(key));
    addDisplayOrder(childDisplayOrder, keySet, menuItem?.displayOrder);
  });

  const getItemDisplayOrder = (item, orderMap) => {
    const keys = [item.name, item.title, item.slug, item.nav]
      .map(normalizeMenuValue)
      .filter(Boolean);

    for (const key of keys) {
      if (orderMap.has(key)) return orderMap.get(key);
    }

    return Number.POSITIVE_INFINITY;
  };

  const sortByDisplayOrder = (items, orderMap) =>
    items
      .map((item, index) => ({ item, index }))
      .sort((a, b) => {
        const orderDifference = getItemDisplayOrder(a.item, orderMap) - getItemDisplayOrder(b.item, orderMap);
        return Number.isNaN(orderDifference) || orderDifference === 0
          ? a.index - b.index
          : orderDifference;
      })
      .map(({ item }) => item);

  const filteredMenu = menuList
    .map((section) => {
      const subItems = section.subItems.filter((item) => {
        const itemKeys = [item.name, item.slug, item.nav].map(normalizeMenuValue).filter(Boolean);
        return itemKeys.some((key) => allowedChildren.has(key));
        // return itemKeys.some((key) => hardcodedMenuKeys.has(key) || allowedChildren.has(key));
      });

      return {
        ...section,
        subItems: sortByDisplayOrder(subItems, childDisplayOrder)
      };
    })
    .filter((section) => section.subItems.length > 0);

  return sortByDisplayOrder(filteredMenu, sectionDisplayOrder);
};

export const getAuthorizedMenuList = (loginMenus = getStoredLoginMenus(), userData = getStoredUser()) => {
  if (!Array.isArray(loginMenus) || loginMenus.length === 0) return [];

  return filterMenuByLoginAccess(
    getMenuListByUserType(userData?.userTypeId || userData?.userType || '', userData?.userCode || ''),
    loginMenus
  );
};

export const DASHBOARD_ROUTE_BY_USER_TYPE = Object.freeze({
  DEALER: '/dealer-one-page-report',
  DIST: '/dealer-one-page-report',
  DISTRIBUTOR: '/dealer-one-page-report',
  AGENCY: '/agency-performance-report',
  AGENT: '/agency-performance-report',
  PRIM: '/report-dashboard'
});

const DASHBOARD_ROUTE_PRIORITY = [
  '/dealer-one-page-report',
  '/agency-performance-report',
  '/report-dashboard'
];

const getAccessibleItems = (loginMenus, userData) =>
  getAuthorizedMenuList(loginMenus, userData)
    .flatMap((section) => section.subItems || [])
    .filter((item) => item?.nav && !item?.disabled);

export const getAssignedDashboardRoute = (loginMenus = getStoredLoginMenus(), userData = getStoredUser()) => {
  const accessibleItems = getAccessibleItems(loginMenus, userData);
  const accessibleRoutes = new Set(accessibleItems.map((item) => normalizeMenuValue(item.nav)));
  const normalizedUserType = String(userData?.userTypeId || userData?.userType || '').trim().toUpperCase();
  const userTypeDashboard = DASHBOARD_ROUTE_BY_USER_TYPE[normalizedUserType];

  // Distributor users always use the dealer dashboard, even when this report
  // is not returned separately in their assigned login-menu list.
  if (['DIST', 'DISTRIBUTOR'].includes(normalizedUserType)) {
    return '/dealer-one-page-report';
  }

  if (userTypeDashboard && accessibleRoutes.has(normalizeMenuValue(userTypeDashboard))) {
    return userTypeDashboard;
  }

  return DASHBOARD_ROUTE_PRIORITY.find((route) => accessibleRoutes.has(normalizeMenuValue(route))) || '';
};

export const getDefaultAuthorizedRoute = (loginMenus = getStoredLoginMenus(), userData = getStoredUser()) => {
  const accessibleItems = getAccessibleItems(loginMenus, userData);
  const assignedDashboard = getAssignedDashboardRoute(loginMenus, userData);

  return assignedDashboard || accessibleItems[0]?.nav || '/404';
};

export const getNavigationMenuList = (loginMenus = getStoredLoginMenus(), userData = getStoredUser()) => {
  const authorizedMenus = getAuthorizedMenuList(loginMenus, userData);
  const dashboardRoute = getAssignedDashboardRoute(loginMenus, userData);
  if (!dashboardRoute) return authorizedMenus;

  const dashboardRouteKeys = new Set(DASHBOARD_ROUTE_PRIORITY.map(normalizeMenuValue));
  const withoutDashboardDuplicates = authorizedMenus
    .map((section) => ({
      ...section,
      subItems: (section.subItems || []).filter((item) => !dashboardRouteKeys.has(normalizeMenuValue(item?.nav)))
    }))
    .filter((section) => section.subItems.length > 0);
  const dashboardItem = { name: 'Dashboard', slug: 'dashboard', nav: dashboardRoute, image: home };
  const exploreIndex = withoutDashboardDuplicates.findIndex(
    (section) => normalizeMenuValue(section?.slug || section?.title) === 'explore'
  );

  if (exploreIndex >= 0) {
    return withoutDashboardDuplicates.map((section, index) =>
      index === exploreIndex
        ? { ...section, subItems: [dashboardItem, ...section.subItems] }
        : section
    );
  }

  return [
    { title: 'Explore', slug: 'explore', subItems: [dashboardItem] },
    ...withoutDashboardDuplicates
  ];
};

export const hasAuthorizedMenuRoute = (route, loginMenus = getStoredLoginMenus(), userData = getStoredUser()) => {
  const normalizedRoute = normalizeMenuValue(route);
  const normalizedUserType = String(userData?.userTypeId || userData?.userType || '').trim().toUpperCase();

  if (
    ['DIST', 'DISTRIBUTOR'].includes(normalizedUserType) &&
    normalizedRoute === normalizeMenuValue('/dealer-one-page-report')
  ) {
    return true;
  }

  return getAuthorizedMenuList(loginMenus, userData)
    .flatMap((section) => section.subItems || [])
    .some((item) => normalizeMenuValue(item?.nav) === normalizedRoute);
};

const detectedUserType = (() => {
  try {
    if (typeof window === 'undefined') return '';
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.userTypeId || '';
  } catch {
    return '';
  }
})();

const detectedUserCode = (() => {
  try {
    if (typeof window === 'undefined') return '';
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.userCode || '';
  } catch {
    return '';
  }
})();

export const menulist = filterMenuByLoginAccess(
  getMenuListByUserType(detectedUserType, detectedUserCode),
  getStoredLoginMenus()
);

export { filterMenuByLoginAccess, getStoredLoginMenus };
